module.exports = __webpack_public_path__ + "img/class9.5223d464.png";